(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3588,4291],{

/***/ 91443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ getConfigurationValue; },
/* harmony export */   "l": function() { return /* binding */ getConfigurationBooleanValue; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69826);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _DeviceTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38805);




function getConfigurationValue(availableConfigurations, devicesConfigurations, fieldName, isMobile, isTiny, isTablet) {
  var defaultValue = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var isHomepage = arguments.length > 7 ? arguments[7] : undefined;
  var value = defaultValue;

  if (availableConfigurations.indexOf(_DeviceTypes__WEBPACK_IMPORTED_MODULE_3__/* .DeviceType.All */ .Y.All) >= 0) {
    /*
      if configuration for device type ALL exist, only care about that one
     */
    var configuration = devicesConfigurations.find(function (conf) {
      return conf.fields.deviceType === _DeviceTypes__WEBPACK_IMPORTED_MODULE_3__/* .DeviceType.All */ .Y.All;
    });
    value = configuration.fields[fieldName] || defaultValue;
  } else {
    /*
     in the other case fetch mobile and desktop value and return the one matching the is mobile variable
     given requested value is for mobile and mobile value is empty then use the desktop value
    */
    var tinyConfiguration = devicesConfigurations.find(function (conf) {
      return conf.fields.deviceType === _DeviceTypes__WEBPACK_IMPORTED_MODULE_3__/* .DeviceType.TINY */ .Y.TINY;
    });
    var mobileConfiguration = devicesConfigurations.find(function (conf) {
      return conf.fields.deviceType === _DeviceTypes__WEBPACK_IMPORTED_MODULE_3__/* .DeviceType.MOBILE */ .Y.MOBILE;
    });
    var tabletConfiguration = devicesConfigurations.find(function (conf) {
      return conf.fields.deviceType === _DeviceTypes__WEBPACK_IMPORTED_MODULE_3__/* .DeviceType.TABLET */ .Y.TABLET;
    });
    var desktopConfiguration = devicesConfigurations.find(function (conf) {
      return conf.fields.deviceType === _DeviceTypes__WEBPACK_IMPORTED_MODULE_3__/* .DeviceType.DESKTOP */ .Y.DESKTOP;
    });
    var tinyValue = tinyConfiguration ? tinyConfiguration.fields[fieldName] || defaultValue : defaultValue;
    var mobileValue = mobileConfiguration ? mobileConfiguration.fields[fieldName] || defaultValue : defaultValue;
    var tabletValue = tabletConfiguration ? tabletConfiguration.fields[fieldName] || defaultValue : defaultValue;
    var desktopValue = desktopConfiguration ? desktopConfiguration.fields[fieldName] || defaultValue : defaultValue;

    if (isTiny) {
      value = tinyValue || mobileValue || desktopValue;
    } else if (isMobile) {
      value = mobileValue || tabletValue || desktopValue;
    } else if (isTablet) {
      value = tabletValue || desktopValue;
    } else {
      value = desktopValue;
    }

    if (!isHomepage && isTiny == null && isMobile == null && isTablet == null) {
      value = mobileValue;
    }
  }

  return value;
}
function getConfigurationBooleanValue(availableConfigurations, devicesConfigurations, fieldName, isMobile, isTiny, isTablet) {
  var defaultValue = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var value = defaultValue;

  if (availableConfigurations.indexOf(_DeviceTypes__WEBPACK_IMPORTED_MODULE_3__/* .DeviceType.All */ .Y.All) >= 0) {
    /*
      if configuration for device type ALL exist, only care about that one
     */
    var configuration = devicesConfigurations.find(function (conf) {
      return conf.fields.deviceType === _DeviceTypes__WEBPACK_IMPORTED_MODULE_3__/* .DeviceType.All */ .Y.All;
    });
    value = configuration.fields[fieldName] ? configuration.fields[fieldName] : defaultValue;
  } else {
    /*
     in the other case fetch mobile and desktop value and return the one matching the is mobile variable
     given requested value is for mobile and mobile value is empty then use the desktop value
    */
    var tinyConfiguration = devicesConfigurations.find(function (conf) {
      return conf.fields.deviceType === _DeviceTypes__WEBPACK_IMPORTED_MODULE_3__/* .DeviceType.TINY */ .Y.TINY;
    });
    var mobileConfiguration = devicesConfigurations.find(function (conf) {
      return conf.fields.deviceType === _DeviceTypes__WEBPACK_IMPORTED_MODULE_3__/* .DeviceType.MOBILE */ .Y.MOBILE;
    });
    var tabletConfiguration = devicesConfigurations.find(function (conf) {
      return conf.fields.deviceType === _DeviceTypes__WEBPACK_IMPORTED_MODULE_3__/* .DeviceType.TABLET */ .Y.TABLET;
    });
    var desktopConfiguration = devicesConfigurations.find(function (conf) {
      return conf.fields.deviceType === _DeviceTypes__WEBPACK_IMPORTED_MODULE_3__/* .DeviceType.DESKTOP */ .Y.DESKTOP;
    });
    var tinyValue = tinyConfiguration && tinyConfiguration.fields[fieldName] ? tinyConfiguration.fields[fieldName] : defaultValue;
    var mobileValue = mobileConfiguration && mobileConfiguration.fields[fieldName] ? mobileConfiguration.fields[fieldName] : defaultValue;
    var tabletValue = tabletConfiguration && tabletConfiguration.fields[fieldName] ? tabletConfiguration.fields[fieldName] : defaultValue;
    var desktopValue = desktopConfiguration && desktopConfiguration.fields[fieldName] ? desktopConfiguration.fields[fieldName] : defaultValue;

    if (isTiny) {
      value = tinyValue || mobileValue || desktopValue;
    } else if (isMobile) {
      value = mobileValue || tabletValue || desktopValue;
    } else if (isTablet) {
      value = tabletValue || desktopValue;
    } else {
      value = desktopValue;
    }
  }

  return value;
}

/***/ }),

/***/ 38805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DeviceType; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43371);
/* harmony import */ var core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_0__);

var DeviceType = Object.freeze({
  All: 'all',
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
  TINY: 'tiny',
  TABLET: 'tablet'
});

/***/ }),

/***/ 71357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LI": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "Ui": function() { return /* binding */ mediaQueryHOC; },
/* harmony export */   "ag": function() { return /* binding */ useMatchMedia; },
/* harmony export */   "hZ": function() { return /* binding */ useScrollBlock; },
/* harmony export */   "y3": function() { return /* binding */ updateCurrentProductIndex; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91058);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85893);














function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

 // https://github.com/streamich/react-use/blob/master/docs/useIsomorphicLayoutEffect.md


var useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_13__.useLayoutEffect : 0;
function useMatchMedia(mediaQueryString) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(initialValue),
      match = _useState[0],
      setMatch = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function () {
    if (!window.matchMedia) {
      return;
    }

    function handleMatch(event) {
      setMatch(event.matches);
    }

    var matchMedia = window.matchMedia(mediaQueryString);
    setMatch(matchMedia.matches);
    matchMedia.addListener(handleMatch);
    return function () {
      matchMedia.removeListener(handleMatch);
    };
  }, [mediaQueryString]);
  return match;
}
var mediaQueryHOC = function mediaQueryHOC(Component) {
  function MediaQueryHOC(props) {
    var isXSmall = useMatchMedia('(max-width: 375px)');
    var isSmall = useMatchMedia('(max-width: 479px)');
    var isMedium = useMatchMedia('(max-width: 767px)');
    var isLarge = useMatchMedia('(max-width: 991px)');
    var isXLarge = useMatchMedia('(max-width: 1023px)');
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(Component, _objectSpread({
      isXSmall: isXSmall,
      isSmall: isSmall,
      isMedium: isMedium,
      isLarge: isLarge,
      isXLarge: isXLarge
    }, props));
  }

  return MediaQueryHOC;
};
var listeners = [];
var state = {
  currentProductIndex: 0
};

var setState = function setState(newState) {
  state = _objectSpread(_objectSpread({}, state), newState);
  listeners.forEach(function (listener) {
    listener(state);
  });
};

var updateCurrentProductIndex = function updateCurrentProductIndex() {
  var newListener = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)()[1];
  (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function () {
    listeners.push(newListener);
  }, []);
  return [state, setState];
};
var useScrollBlock = function useScrollBlock() {
  var scroll = (0,react__WEBPACK_IMPORTED_MODULE_13__.useRef)(false);

  var blockScroll = function blockScroll() {
    if (typeof document === "undefined") return;
    var html = document.documentElement;
    var _document = document,
        body = _document.body;
    if (!(body == null ? void 0 : body.style) || scroll.current) return;
    var scrollBarWidth = window.innerWidth - html.clientWidth;
    var bodyPaddingRight = parseInt(window.getComputedStyle(body).getPropertyValue("padding-right")) || 0;
    Object.assign(html.style, {
      position: "relative",
      overflow: "hidden"
    });
    Object.assign(body.style, {
      position: "relative",
      overflow: "hidden",
      paddingRight: "".concat(bodyPaddingRight + scrollBarWidth, "px")
    });
    scroll.current = true;
  };

  var allowScroll = function allowScroll() {
    if (typeof document === "undefined") return;
    var html = document.documentElement;
    var _document2 = document,
        body = _document2.body;
    if (!(body == null ? void 0 : body.style) || !scroll.current) return;
    Object.assign(html.style, {
      position: "",
      overflow: ""
    });
    Object.assign(body.style, {
      position: "",
      overflow: "",
      paddingRight: ""
    });
    scroll.current = false;
  };

  return [blockScroll, allowScroll];
};

/***/ }),

/***/ 63588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ContentBlockTest": function() { return /* binding */ ContentBlockTest; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_small_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37268);
/* harmony import */ var core_js_modules_es_string_small_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_small_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69826);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26699);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32023);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(40483);
/* harmony import */ var react_scroll_parallax__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(77776);
/* harmony import */ var react_waypoint__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(83824);
/* harmony import */ var _adapters_helpers_DeviceTypes__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(38805);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(24036);
/* harmony import */ var _adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8996);
/* harmony import */ var _adapters_helpers_ContentBlockConfiguration__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(91443);
/* harmony import */ var _Label_Label__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(44291);
/* harmony import */ var _adapters_helpers_Hooks__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(71357);
/* harmony import */ var _adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(47322);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(85893);
























var BodyText = next_dynamic__WEBPACK_IMPORTED_MODULE_13___default()(function () {
  return __webpack_require__.e(/* import() */ 9875).then(__webpack_require__.bind(__webpack_require__, 9875));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9875)];
    }
  }
});
var Button = next_dynamic__WEBPACK_IMPORTED_MODULE_13___default()(function () {
  return __webpack_require__.e(/* import() */ 9246).then(__webpack_require__.bind(__webpack_require__, 99246));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(99246)];
    }
  }
});
var Disclaimer = next_dynamic__WEBPACK_IMPORTED_MODULE_13___default()(function () {
  return __webpack_require__.e(/* import() */ 6809).then(__webpack_require__.bind(__webpack_require__, 77770));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(77770)];
    }
  }
});
var Heading = next_dynamic__WEBPACK_IMPORTED_MODULE_13___default()(function () {
  return __webpack_require__.e(/* import() */ 2116).then(__webpack_require__.bind(__webpack_require__, 92116));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(92116)];
    }
  }
});
var Icon = next_dynamic__WEBPACK_IMPORTED_MODULE_13___default()(function () {
  return __webpack_require__.e(/* import() */ 713).then(__webpack_require__.bind(__webpack_require__, 80713));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(80713)];
    }
  }
});
var Image = next_dynamic__WEBPACK_IMPORTED_MODULE_13___default()(function () {
  return __webpack_require__.e(/* import() */ 8084).then(__webpack_require__.bind(__webpack_require__, 48084));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(48084)];
    }
  }
});
var ObLink = next_dynamic__WEBPACK_IMPORTED_MODULE_13___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(8958)]).then(__webpack_require__.bind(__webpack_require__, 61769));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61769)];
    }
  }
});
var BackgroundWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_13___default()(function () {
  return __webpack_require__.e(/* import() */ 366).then(__webpack_require__.bind(__webpack_require__, 40366));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(40366)];
    }
  }
});


/**
 *
 * Supported Classes:
 *  By default the background is white and the text color is primary-grey.
 *  The CTA is a Button by default
 *
 *  - background-primary-grey : change the background to primary grey
 *  - background-secondary-grey : change the background to secondary grey
 *  - background-secondary-off-white : change the background to secondary-off-white
 *  - background-isolate-grey : change the background to isolate grey
 *  - background-primary-blue : change the background to primary-blue
 *  - background-secondary-blue : change the background to secondary-blue
 *
 */





function ContentBlock(props) {
  var _blockState$backgroun, _blockState$backgroun2, _block$props, _block$props$document, _block$props$document2, _mobiledeviceConfigur8, _isContentMobile$, _isContentMobile$2, _isContentMobile$3, _isContentMobile$4;

  var isXSmall = props.isXSmall,
      isSmall = props.isSmall,
      isMedium = props.isMedium,
      isXLarge = props.isXLarge;

  var valueOf = function valueOf(name) {
    var value = undefined;

    if (name && block && block.getFieldValue(name) !== undefined) {
      value = block.getFieldValue(name);
    }

    return value;
  };

  var generateContentblockState = function generateContentblockState() {
    var devicesConfigurationsData = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.devicesConfigurations */ .Kd.devicesConfigurations);
    return {
      availableConfigurations: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.devicesConfigurations */ .Kd.devicesConfigurations).map(function (configuration) {
        return configuration.fields.deviceType;
      }),
      isContentImageAndTextSeparate: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.devicesConfigurations */ .Kd.devicesConfigurations).map(function (configuration) {
        var _configuration$fields;

        return configuration == null ? void 0 : (_configuration$fields = configuration.fields) == null ? void 0 : _configuration$fields.isContentImageAndTextSeparate;
      }),
      blockMinHeight: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.blockMinHeight */ .Kd.blockMinHeight, isMedium, isXSmall, isXLarge, ''),
      isRemoveParallax: configurationBooleanValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.isRemoveParallax */ .Kd.isRemoveParallax, isMedium, isXSmall, isXLarge),
      blockMarginTop: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.blockMarginTop */ .Kd.blockMarginTop, isMedium, isXSmall, isXLarge, ''),
      blockMarginBottom: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.blockMarginBottom */ .Kd.blockMarginBottom, isMedium, isXSmall, isXLarge, ''),
      blockMarginRight: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.blockMarginRight */ .Kd.blockMarginRight, isMedium, isXSmall, isXLarge, ''),
      blockMarginLeft: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.blockMarginLeft */ .Kd.blockMarginLeft, isMedium, isXSmall, isXLarge, ''),
      blockPadding: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.blockPadding */ .Kd.blockPadding, isMedium, isXSmall, isXLarge, ''),
      textAlign: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textAlign */ .Kd.textAlign, isMedium, isXSmall, isXLarge, ''),
      textContainerWidth: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textContainerWidth */ .Kd.textContainerWidth, isMedium, isXSmall, isXLarge, ''),
      titleWidth: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.titleWidth */ .Kd.titleWidth, isMedium, isXSmall, isXLarge, ''),
      descriptionWidth: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.descriptionWidth */ .Kd.descriptionWidth, isMedium, isXSmall, isXLarge, ''),
      textContainerHorizontalAlignment: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textContainerHorizontalAlignment */ .Kd.textContainerHorizontalAlignment, isMedium, isXSmall, isXLarge, ''),
      textContainerVerticalAlignment: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textContainerVerticalAlignment */ .Kd.textContainerVerticalAlignment, isMedium, isXSmall, isXLarge, ''),
      textContainerOffset: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textContainerOffset */ .Kd.textContainerOffset, isMedium, isXSmall, isXLarge, ''),
      textContainerMarginRight: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textContainerMarginRight */ .Kd.textContainerMarginRight, isMedium, isXSmall, isXLarge, ''),
      textContainerMarginLeft: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textContainerMarginLeft */ .Kd.textContainerMarginLeft, isMedium, isXSmall, isXLarge, ''),
      textContainerMarginBottom: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textContainerMarginBottom */ .Kd.textContainerMarginBottom, isMedium, isXSmall, isXLarge, ''),
      mainAsset: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.mainAsset */ .Kd.mainAsset, isMedium, isXSmall, isXLarge),
      mainAssetBelowOrAboveText: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.mainAssetBelowOrAboveText */ .Kd.mainAssetBelowOrAboveText, isMedium, isXSmall, isXLarge, ''),
      mainAssetMaxWidth: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.mainAssetMaxWidth */ .Kd.mainAssetMaxWidth, isMedium, isXSmall, isXLarge, ''),
      mainAssetMaxHeight: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.mainAssetMaxHeight */ .Kd.mainAssetMaxHeight, isMedium, isXSmall, isXLarge, ''),
      mainAssetHeight: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.mainAssetHeight */ .Kd.mainAssetHeight, isMedium, isXSmall, isXLarge, ''),
      mainAssetOffsetTop: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.mainAssetMarginTop */ .Kd.mainAssetMarginTop, isMedium, isXSmall, isXLarge, ''),
      mainAssetOffsetRight: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.mainAssetMarginRight */ .Kd.mainAssetMarginRight, isMedium, isXSmall, isXLarge, ''),
      mainAssetOffsetBottom: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.mainAssetOffsetBottom */ .Kd.mainAssetOffsetBottom, isMedium, isXSmall, isXLarge, ''),
      mainAssetOffsetLeft: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.mainAssetOffsetLeft */ .Kd.mainAssetOffsetLeft, isMedium, isXSmall, isXLarge, ''),
      mainAssetScale: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.mainAssetScale */ .Kd.mainAssetScale, isMedium, isXSmall, isXLarge, ''),
      backgroundAsset: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.backgroundAsset */ .Kd.backgroundAsset, isMedium, isXSmall, isXLarge),
      mainAssetHorizontalAlignment: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.mainAssetHorizontalAlignment */ .Kd.mainAssetHorizontalAlignment, isMedium, isXSmall, isXLarge),
      mainAssetVerticalAlignment: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.mainAssetVerticalAlignment */ .Kd.mainAssetVerticalAlignment, isMedium, isXSmall, isXLarge),
      backgroundPosition: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.backgroundPosition */ .Kd.backgroundPosition, isMedium, isXSmall, isXLarge, ''),
      sectionOffsetTop: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.sectionOffsetTop */ .Kd.sectionOffsetTop, isMedium, isXSmall, isXLarge, ''),
      mainAssetParallax: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.mainAssetParallax */ .Kd.mainAssetParallax, isMedium, isXSmall, isXLarge, ''),
      mainAssetParallaxSetting: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.mainAssetParallaxSetting */ .Kd.mainAssetParallaxSetting, isMedium, isXSmall, isXLarge, ''),
      textParallax: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textParallax */ .Kd.textParallax, isMedium, isXSmall, isXLarge, ''),
      textParallaxSetting: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textParallaxSetting */ .Kd.textParallaxSetting, isMedium, isXSmall, isXLarge, ''),
      textParallaxConfiguration: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textParallaxConfiguration */ .Kd.textParallaxConfiguration, isMedium, isXSmall, isXLarge, ''),
      assetParallaxConfiguration: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.assetParallaxConfiguration */ .Kd.assetParallaxConfiguration, isMedium, isXSmall, isXLarge, ''),
      textShowAnimation: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textShowAnimation */ .Kd.textShowAnimation, isMedium, isXSmall, isXLarge, ''),
      textFadeIn: configurationBooleanValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textFadeIn */ .Kd.textFadeIn, isMedium, isXSmall, isXLarge),
      textColor: configurationBooleanValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textColor */ .Kd.textColor, isMedium, isXSmall, isXLarge),
      respectImageAspectRatio: configurationBooleanValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.respectImageAspectRatio */ .Kd.respectImageAspectRatio, isMedium, isXSmall, isXLarge),
      textContainerBackgroundColor: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textContainerBackgroundColor */ .Kd.textContainerBackgroundColor, isMedium, isXSmall, isXLarge),
      textContainerBackgroundOpacity: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textContainerBackgroundOpacity */ .Kd.textContainerBackgroundOpacity, isMedium, isXSmall, isXLarge),
      secondaryAsset: configurationValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.secondaryAsset */ .Kd.secondaryAsset, isMedium, isXSmall, isXLarge)
    };
  };

  var configurationValue = function configurationValue(fieldName, isMedium, isXSmall, isXLarge) {
    var defaultValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var isHomepage = false;

    if ((props == null ? void 0 : props.className) == 'ob-homepage-hero-block' || valueOf('isRemoveParallax')) {
      isHomepage = true;
    }

    return (0,_adapters_helpers_ContentBlockConfiguration__WEBPACK_IMPORTED_MODULE_21__/* .getConfigurationValue */ .M)(availableConfigurations, valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.devicesConfigurations */ .Kd.devicesConfigurations), fieldName, isMedium, isXSmall, isXLarge, defaultValue, isHomepage);
  };

  var configurationBooleanValue = function configurationBooleanValue(fieldName, isMedium, isXSmall, isXLarge) {
    var defaultValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    return (0,_adapters_helpers_ContentBlockConfiguration__WEBPACK_IMPORTED_MODULE_21__/* .getConfigurationBooleanValue */ .l)(availableConfigurations, valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.devicesConfigurations */ .Kd.devicesConfigurations), fieldName, isMedium, isXSmall, isXLarge, defaultValue);
  };

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(''),
      show = _useState[0],
      setShow = _useState[1];

  var _handleWaypointEnter = function _handleWaypointEnter() {
    // Trigger by waypoint enter
    showContentElement();
  };

  var showContentElement = function showContentElement() {
    // Animation on the text container on the 'onEnter' event
    setShow('show');
  };

  var getTitleFontSize = function getTitleFontSize() {
    // By default the Title font size is medium.
    var titleFontSize = '';

    switch (valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.titleFontSize */ .Kd.titleFontSize)) {
      case _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.small */ .Kd.small:
        titleFontSize = 'ob-display-3-xl';
        break;

      case _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.medium */ .Kd.medium:
        titleFontSize = 'ob-display-2-xl';
        break;

      case _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.large */ .Kd.large:
        titleFontSize = 'ob-display-1-xl';
        break;

      default:
        titleFontSize = 'ob-display-2-xl';
    }

    return titleFontSize;
  };

  var getParallaxConfigurationValue = function getParallaxConfigurationValue(hasParallax, parallaxConfigurationAttribute, axis) {
    var value = [0, 0];
    var srcAttr = axis + _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.Src */ .Kd.Src;
    var destAttr = axis + _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.Dest */ .Kd.Dest;

    if (hasParallax && !(0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_20__/* .isIE */ .w1)()) {
      if (blockState[parallaxConfigurationAttribute].fields[srcAttr] && blockState[parallaxConfigurationAttribute].fields[destAttr]) {
        value = [blockState[parallaxConfigurationAttribute].fields[srcAttr], blockState[parallaxConfigurationAttribute].fields[destAttr]];
      }
    }

    return value;
  };

  var renderDisclaimer = function renderDisclaimer() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
      className: 'ob-contentBlock-disclaimer',
      style: {
        width: blockState.textContainerWidth ? blockState.textContainerWidth : null,
        textAlign: blockState.textAlign ? blockState.textAlign : null
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Disclaimer, {
        whiteText: isWhiteText,
        document: disclaimerReference
      })
    });
  };

  var block = new _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z(props);
  var devicesConfigurationsData = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.devicesConfigurations */ .Kd.devicesConfigurations);
  var availableConfigurations = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.devicesConfigurations */ .Kd.devicesConfigurations).map(function (configuration) {
    return configuration.fields.deviceType;
  });
  var isContentMobile = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.devicesConfigurations */ .Kd.devicesConfigurations).map(function (configuration) {
    var _configuration$fields2, _configuration$fields3;

    return {
      isContentImageAndTextSeparate: configuration == null ? void 0 : (_configuration$fields2 = configuration.fields) == null ? void 0 : _configuration$fields2.isContentImageAndTextSeparate,
      deviceType: configuration == null ? void 0 : (_configuration$fields3 = configuration.fields) == null ? void 0 : _configuration$fields3.deviceType
    };
  });
  var className = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.classNames */ .Kd.classNames);
  var isContentHyperlinkBlock = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.isContentHyperlinkBlock */ .Kd.isContentHyperlinkBlock);
  var blockHyperlink = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.blockHyperlink */ .Kd.blockHyperlink);
  var isALink = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionIsALink */ .Kd.callToActionIsALink);
  var title = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.title */ .Kd.title);
  var isPopupCTA = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.isPopupCta */ .Kd.isPopupCta);
  var imagePopup = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.imagePopup */ .Kd.imagePopup);
  var titleLevel = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.titleLevel */ .Kd.titleLevel);
  var blueEyebrow = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.blueEyebrow */ .Kd.blueEyebrow);
  var mobileMainHeading = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.mobileMainHeading */ .Kd.mobileMainHeading);

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var titleFontSize = getTitleFontSize();
  var disclaimerReference = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.disclaimerReference */ .Kd.disclaimerReference);
  var textsImage = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textsImage */ .Kd.textsImage);
  var anchorId = block.getAnchorId();

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(generateContentblockState()),
      blockState = _useState3[0],
      setblockState = _useState3[1];

  var pauseLabel = (0,_Label_Label__WEBPACK_IMPORTED_MODULE_22__.Label)({
    label: block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.pauseLabel */ .Kd.pauseLabel)
  });
  var playLabel = (0,_Label_Label__WEBPACK_IMPORTED_MODULE_22__.Label)({
    label: block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.playLabel */ .Kd.playLabel)
  });
  var resetLabel = (0,_Label_Label__WEBPACK_IMPORTED_MODULE_22__.Label)({
    label: block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.resetLabel */ .Kd.resetLabel)
  });
  var openTranscriptLabel = (0,_Label_Label__WEBPACK_IMPORTED_MODULE_22__.Label)({
    label: block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.openTranscriptLabel */ .Kd.openTranscriptLabel)
  });
  var closeTranscriptLabel = (0,_Label_Label__WEBPACK_IMPORTED_MODULE_22__.Label)({
    label: block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.closeTranscriptLabel */ .Kd.closeTranscriptLabel)
  });
  var hasDivider = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.hasDivider */ .Kd.hasDivider);
  var isRemoveParallax = blockState.isRemoveParallax;
  var appStoreImage = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.appStoreIcon */ .Kd.appStoreIcon);
  var noteText = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.noteText */ .Kd.noteText);
  var eventClassName = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.eventClassName */ .Kd.eventClassName);
  var backgroundColor = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.backgroundColor */ .Kd.backgroundColor);
  var ctaBackgroundColor = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.ctaBackgroundColor */ .Kd.ctaBackgroundColor);
  var CtalabelId = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.CtalabelId */ .Kd.CtalabelId);
  var dataActionDetailPresent = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.dataActionDetailLabel */ .Kd.dataActionDetailLabel);
  var callToActionAriaLabel = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionAriaLabel */ .Kd.callToActionAriaLabel);
  var callToActionLabel = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLabel */ .Kd.callToActionLabel);
  var surtitle = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.surtitle */ .Kd.surtitle);
  var descriptionBelowOption = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.descriptionBelowOption */ .Kd.descriptionBelowOption);
  var callToActionType = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionType */ .Kd.callToActionType);
  var callToActionTitle = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionTitle */ .Kd.callToActionTitle);
  var gaEvents = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.gaEvents */ .Kd.gaEvents);
  var contentOptions = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.contentOptions */ .Kd.contentOptions);
  var contentOptionClassName = (0,_Label_Label__WEBPACK_IMPORTED_MODULE_22__.Label)({
    label: block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.contentOptionClassName */ .Kd.contentOptionClassName)
  });
  var textContainerBackgroundColor = null;

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWidth */ .Kd.defaultWidth),
      windowWidth = _useState4[0],
      setWindowWidth = _useState4[1];

  var isPreloadimage = false;
  var mobiledeviceConfiguration = '';
  var preloadBackgroundImage = '';

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false),
      isPageLoaded = _useState5[0],
      setIsPageLoaded = _useState5[1];

  var desktopBackgroundImage = '';
  var mobileBackgroundImage = '';
  var textContainerBackgroundColorRGB = (blockState == null ? void 0 : blockState.textContainerBackgroundColor) ? blockState == null ? void 0 : blockState.textContainerBackgroundColor : valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textContainerBackgroundColor */ .Kd.textContainerBackgroundColor);
  var textContainerBackgroundOpacity = 1;

  if (blockState == null ? void 0 : blockState.textContainerBackgroundOpacity) {
    textContainerBackgroundOpacity = blockState == null ? void 0 : blockState.textContainerBackgroundOpacity;
  }

  if (blockState == null ? void 0 : (_blockState$backgroun = blockState.backgroundAsset) == null ? void 0 : (_blockState$backgroun2 = _blockState$backgroun.fields) == null ? void 0 : _blockState$backgroun2.isPreload) {
    isPreloadimage = true;
  }

  if (textContainerBackgroundColorRGB) {
    var colorRgb = (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_20__/* .getRGBFromHexColor */ .DG)(textContainerBackgroundColorRGB);
    textContainerBackgroundColor = "rgba(".concat(colorRgb.red, ", ").concat(colorRgb.green, ", ").concat(colorRgb.blue, ", ").concat(textContainerBackgroundOpacity, ")");
  }

  var textContainerHasPadding = valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textContainerHasPadding */ .Kd.textContainerHasPadding);
  var isTextAlignBottomMobileView = windowWidth <= _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .Constants.desktopViewStart */ .gT.desktopViewStart && (className || '').indexOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textAlignBottomMobileView */ .Kd.textAlignBottomMobileView) > 0;
  var customStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      position: 'absolute',
      background: "linear-gradient(to right bottom, ".concat(backgroundColor, ", ").concat(backgroundColor, ")"),
      border: '15px solid #fff',
      borderRadius: '0',
      fontSize: '1.1rem',
      lineHeight: '0.1rem',
      padding: '0',
      transform: isMedium ? 'translate(-50%, -47%)' : 'translate(-50%, -50%)',
      width: isMedium ? '100%' : 'fit-content',
      height: isMedium ? '39%' : 'auto',
      maxHeight: isMedium ? '80vh' : '100%',
      overflowX: 'hidden'
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function () {
    setIsPageLoaded(true);
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [isPageLoaded]);

  function handleResize() {
    setWindowWidth(window.innerWidth);
  }

  var handleGAEventsFunction = function handleGAEventsFunction(gaEvent) {
    return gaEvent.map(function (events) {
      var _events$fields, _events$fields2, _events$fields3;

      (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_20__/* .handleGAEvents */ .sz)(events == null ? void 0 : (_events$fields = events.fields) == null ? void 0 : _events$fields.gaEventCategory, events == null ? void 0 : (_events$fields2 = events.fields) == null ? void 0 : _events$fields2.gaEventAction, events == null ? void 0 : (_events$fields3 = events.fields) == null ? void 0 : _events$fields3.gaEventLabel);
    });
  };

  var closeModal = function closeModal() {
    setIsModalOpen(false);
  };

  var onClickModalCTA = function onClickModalCTA() {
    setIsModalOpen(true);
  };

  var renderContentOptions = function renderContentOptions() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
      className: "content-options ".concat(contentOptionClassName),
      children: contentOptions.map(function (contentOption) {
        var _option$class, _option$class$fields;

        var option = contentOption == null ? void 0 : contentOption.fields;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
          className: "content-option-parent",
          children: [(option == null ? void 0 : option.subIcon) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Image, {
            className: "post-purchase-app-section__subicon",
            image: option == null ? void 0 : option.subIcon
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
            href: option == null ? void 0 : option.ctaUrl,
            className: (0,_Label_Label__WEBPACK_IMPORTED_MODULE_22__.Label)({
              label: option == null ? void 0 : option["class"]
            }),
            children: [(option == null ? void 0 : option.icon) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Image, {
              className: "post-purchase-app-section__icon",
              image: option == null ? void 0 : option.icon
            }), (option == null ? void 0 : option.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("p", {
              className: "post-purchase-app-section__title",
              children: option == null ? void 0 : option.title
            }), (option == null ? void 0 : option.description) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("p", {
              className: "post-purchase-app-section__description ".concat((option == null ? void 0 : (_option$class = option["class"]) == null ? void 0 : (_option$class$fields = _option$class.fields) == null ? void 0 : _option$class$fields.text) + '-description'),
              dangerouslySetInnerHTML: {
                __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_25___default().sanitize(option == null ? void 0 : option.description)
              }
            }), (option == null ? void 0 : option.label) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Button, {
              className: !gaEvents && eventClassName ? eventClassName : 'event_external_link',
              dataActionDetail: !gaEvents && CtalabelId ? CtalabelId : valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLink */ .Kd.callToActionLink),
              tag: option == null ? void 0 : option.labelTag,
              href: option == null ? void 0 : option.labelUrl,
              onClick: function onClick() {
                gaEvents && handleGAEventsFunction(gaEvents);
              },
              target: option.labelType,
              ariaLabel: option == null ? void 0 : option.label,
              children: option == null ? void 0 : option.label
            })]
          }, option == null ? void 0 : option.name)]
        });
      })
    });
  };

  var renderDescription = function renderDescription() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(BodyText, {
      className: className,
      whiteText: isWhiteText,
      styles: {
        width: blockState.descriptionWidth ? blockState.descriptionWidth : null
      },
      children: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.description */ .Kd.description)
    });
  };

  var renderSubDescription = function renderSubDescription() {
    return valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.subDescription */ .Kd.subDescription) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("p", {
      className: 'ob-sub-description',
      style: {
        color: isWhiteText ? 'white' : 'black'
      },
      children: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.subDescription */ .Kd.subDescription)
    });
  };

  var renderCta = function renderCta() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
      className: "ob-contentBlock-textContent-obLink-container",
      children: isALink ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)(ObLink, {
        href: "".concat(valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLink */ .Kd.callToActionLink)),
        className: "event_external_link ".concat(ctaBackgroundColor === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.white */ .Kd.white ? _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.white */ .Kd.white : _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.primaryGrey */ .Kd.primaryGrey, " ").concat(isWhiteText ? _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.white */ .Kd.white : _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.primaryGrey */ .Kd.primaryGrey),
        dataActionDetail: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLink */ .Kd.callToActionLink),
        icon: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.chevronRight */ .Kd.chevronRight,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Icon, {
          name: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.chevronRight */ .Kd.chevronRight,
          roundedIcon: isWhiteText ? _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.white */ .Kd.white : _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.blue */ .Kd.blue,
          "aria-hidden": "true"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("span", {
          dangerouslySetInnerHTML: {
            __html: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLabel */ .Kd.callToActionLabel)
          }
        })]
      }) : isPopupCTA ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Button, {
          whiteTheme: isWhiteText || ctaBackgroundColor === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.white */ .Kd.white || ctaBackgroundColor === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.White */ .Kd.White,
          borderTheme: !isWhiteText && !isBlueBorder && ctaBackgroundColor === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.transparentWithBorder */ .Kd.transparentWithBorder,
          borderThemeBlue: !isWhiteText && isBlueBorder && ctaBackgroundColor === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.transparentWithBorder */ .Kd.transparentWithBorder,
          invertedTheme: isWhiteText && ctaBackgroundColor === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.transparentWithBorder */ .Kd.transparentWithBorder,
          tag: "a",
          onClick: onClickModalCTA,
          className: 'event_external_link',
          dataActionDetail: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLink */ .Kd.callToActionLink),
          href: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLink */ .Kd.callToActionLink),
          ariaLabel: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.surtitle */ .Kd.surtitle) ? "".concat((0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_20__/* .stripHtml */ .Vt)("".concat(valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.surtitle */ .Kd.surtitle))), "-").concat(valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLabel */ .Kd.callToActionLabel)) : "".concat(valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLabel */ .Kd.callToActionLabel)),
          title: "".concat(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.ctaName */ .Kd.ctaName, "-").concat(valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLabel */ .Kd.callToActionLabel)),
          children: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLabel */ .Kd.callToActionLabel)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)((react_modal__WEBPACK_IMPORTED_MODULE_14___default()), {
          isOpen: isModalOpen,
          onRequestClose: closeModal,
          closeTimeoutMS: 250,
          style: customStyles,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
            className: 'ob-spotlight-waitlist__modal-contents',
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("img", {
              alt: "store-map",
              className: "store-map",
              src: imagePopup
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("button", {
              className: "event_close_window ob-modal-close",
              onClick: closeModal,
              type: "button",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Icon, {
                name: "close",
                size: "2.4",
                color: "#000"
              })
            })]
          })
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Button, {
        whiteTheme: isWhiteText || ctaBackgroundColor === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.white */ .Kd.white || ctaBackgroundColor === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.White */ .Kd.White,
        isPopupCTA: isPopupCTA,
        imagePopup: imagePopup,
        borderTheme: !isWhiteText && !isBlueBorder && ctaBackgroundColor === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.transparentWithBorder */ .Kd.transparentWithBorder,
        borderThemeBlue: !isWhiteText && isBlueBorder && ctaBackgroundColor === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.transparentWithBorder */ .Kd.transparentWithBorder,
        invertedTheme: isWhiteText && ctaBackgroundColor === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.transparentWithBorder */ .Kd.transparentWithBorder,
        tag: "a",
        target: callToActionType ? callToActionType : '',
        onClick: function onClick() {
          gaEvents && handleGAEventsFunction(gaEvents);
        },
        className: !gaEvents && eventClassName ? eventClassName : 'event_external_link',
        dataActionDetailPresent: dataActionDetailPresent,
        dataActionDetail: !gaEvents && CtalabelId ? CtalabelId : valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLink */ .Kd.callToActionLink),
        href: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLink */ .Kd.callToActionLink),
        ariaLabel: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionAriaLabel */ .Kd.callToActionAriaLabel) ? valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionAriaLabel */ .Kd.callToActionAriaLabel) : valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.surtitle */ .Kd.surtitle) ? "".concat((0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_20__/* .stripHtml */ .Vt)("".concat(valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.surtitle */ .Kd.surtitle))), "-").concat(valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLabel */ .Kd.callToActionLabel)) : "".concat(valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLabel */ .Kd.callToActionLabel)),
        title: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionTitle */ .Kd.callToActionTitle) ? valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionTitle */ .Kd.callToActionTitle) : '',
        id: CtalabelId,
        children: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.callToActionLabel */ .Kd.callToActionLabel)
      })
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function () {
    if (blockState.textFadeIn == false) {
      //If text fadeIn at false show the element at pageLoad
      showContentElement();
    }

    if (block.props.document.fields.devicesConfigurations) {
      setblockState(generateContentblockState());
    }

    if (document.querySelector('.announcement') && document.querySelector('.announcement').innerHTML === '') {
      (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_20__/* .bestCleanAnnouncementBarAlignment */ .l4)();
    }
  }, [isMedium, isXSmall, isXLarge]);

  if (block == null ? void 0 : (_block$props = block.props) == null ? void 0 : (_block$props$document = _block$props.document) == null ? void 0 : (_block$props$document2 = _block$props$document.fields) == null ? void 0 : _block$props$document2.devicesConfigurations) {
    var _mobiledeviceConfigur, _mobiledeviceConfigur2, _mobiledeviceConfigur3, _mobiledeviceConfigur4, _tempdesktopDeviceCon, _tempdesktopDeviceCon2, _tempmobileDeviceConf, _tempmobileDeviceConf2;

    mobiledeviceConfiguration = block.props.document.fields.devicesConfigurations;
    var tempmobiledeviceConfiguration = mobiledeviceConfiguration.find(function (conf) {
      return conf.fields.deviceType === _adapters_helpers_DeviceTypes__WEBPACK_IMPORTED_MODULE_18__/* .DeviceType.TINY */ .Y.TINY;
    });
    var tempdesktopDeviceConfiguration = mobiledeviceConfiguration.find(function (conf) {
      return conf.fields.deviceType === _adapters_helpers_DeviceTypes__WEBPACK_IMPORTED_MODULE_18__/* .DeviceType.DESKTOP */ .Y.DESKTOP;
    });
    var tempmobileDeviceConfiguration = mobiledeviceConfiguration.find(function (conf) {
      return conf.fields.deviceType === _adapters_helpers_DeviceTypes__WEBPACK_IMPORTED_MODULE_18__/* .DeviceType.MOBILE */ .Y.MOBILE;
    });

    if (typeof tempmobiledeviceConfiguration === 'undefined') {
      mobiledeviceConfiguration = mobiledeviceConfiguration.find(function (conf) {
        return conf.fields.deviceType === _adapters_helpers_DeviceTypes__WEBPACK_IMPORTED_MODULE_18__/* .DeviceType.MOBILE */ .Y.MOBILE;
      });
    } else {
      mobiledeviceConfiguration = tempmobiledeviceConfiguration;
    }

    if ((_mobiledeviceConfigur = mobiledeviceConfiguration) == null ? void 0 : (_mobiledeviceConfigur2 = _mobiledeviceConfigur.fields) == null ? void 0 : (_mobiledeviceConfigur3 = _mobiledeviceConfigur2.backgroundAsset) == null ? void 0 : (_mobiledeviceConfigur4 = _mobiledeviceConfigur3.fields) == null ? void 0 : _mobiledeviceConfigur4.isPreload) {
      var _mobiledeviceConfigur5, _mobiledeviceConfigur6, _mobiledeviceConfigur7;

      preloadBackgroundImage = (_mobiledeviceConfigur5 = mobiledeviceConfiguration) == null ? void 0 : (_mobiledeviceConfigur6 = _mobiledeviceConfigur5.fields) == null ? void 0 : (_mobiledeviceConfigur7 = _mobiledeviceConfigur6.backgroundAsset) == null ? void 0 : _mobiledeviceConfigur7.fields;
    }

    if (tempdesktopDeviceConfiguration == null ? void 0 : (_tempdesktopDeviceCon = tempdesktopDeviceConfiguration.fields) == null ? void 0 : (_tempdesktopDeviceCon2 = _tempdesktopDeviceCon.backgroundAsset) == null ? void 0 : _tempdesktopDeviceCon2.fields) {
      var _tempdesktopDeviceCon3, _tempdesktopDeviceCon4;

      desktopBackgroundImage = tempdesktopDeviceConfiguration == null ? void 0 : (_tempdesktopDeviceCon3 = tempdesktopDeviceConfiguration.fields) == null ? void 0 : (_tempdesktopDeviceCon4 = _tempdesktopDeviceCon3.backgroundAsset) == null ? void 0 : _tempdesktopDeviceCon4.fields;
    }

    if (tempmobileDeviceConfiguration == null ? void 0 : (_tempmobileDeviceConf = tempmobileDeviceConfiguration.fields) == null ? void 0 : (_tempmobileDeviceConf2 = _tempmobileDeviceConf.backgroundAsset) == null ? void 0 : _tempmobileDeviceConf2.fields) {
      var _tempmobileDeviceConf3, _tempmobileDeviceConf4;

      mobileBackgroundImage = tempmobileDeviceConfiguration == null ? void 0 : (_tempmobileDeviceConf3 = tempmobileDeviceConfiguration.fields) == null ? void 0 : (_tempmobileDeviceConf4 = _tempmobileDeviceConf3.backgroundAsset) == null ? void 0 : _tempmobileDeviceConf4.fields;
    }
  }

  mobiledeviceConfiguration = (_mobiledeviceConfigur8 = mobiledeviceConfiguration) == null ? void 0 : _mobiledeviceConfigur8.fields;
  var hasTextParallax = blockState.textParallaxConfiguration ? true : false;
  var textX = getParallaxConfigurationValue(hasTextParallax, _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textParallaxConfiguration */ .Kd.textParallaxConfiguration, _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.x */ .Kd.x);
  var textY = getParallaxConfigurationValue(hasTextParallax, _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.textParallaxConfiguration */ .Kd.textParallaxConfiguration, _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.y */ .Kd.y);
  var hasAssetParallax = blockState.assetParallaxConfiguration ? true : false;
  var assetX = getParallaxConfigurationValue(hasAssetParallax, _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.assetParallaxConfiguration */ .Kd.assetParallaxConfiguration, _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.x */ .Kd.x);
  var assetY = getParallaxConfigurationValue(hasAssetParallax, _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.assetParallaxConfiguration */ .Kd.assetParallaxConfiguration, _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.y */ .Kd.y);
  var isWhiteText = (blockState == null ? void 0 : blockState.textColor) === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.White */ .Kd.White ? true : false;
  var isBlueBorder = className == null ? void 0 : className.includes(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.blueBorderBtn */ .Kd.blueBorderBtn);
  var isRenderAppIcons = appStoreImage && googlePlayImage;

  var parallexCont = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(react__WEBPACK_IMPORTED_MODULE_12__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)(react__WEBPACK_IMPORTED_MODULE_12__.Suspense, {
      fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_24__["default"], {}),
      children: [textsImage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
        className: "ob-contentBlock-text-image",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(react__WEBPACK_IMPORTED_MODULE_12__.Suspense, {
          fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_24__["default"], {}),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Image, {
            image: textsImage
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("p", {
        className: 'ob-eyebrow',
        "data-white-text": isWhiteText,
        "data-blue-text": blueEyebrow,
        dangerouslySetInnerHTML: {
          __html: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.surtitle */ .Kd.surtitle)
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(react__WEBPACK_IMPORTED_MODULE_12__.Suspense, {
        fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_24__["default"], {}),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Heading, {
          className: titleFontSize,
          whiteText: isWhiteText,
          tag: titleLevel ? "h".concat(titleLevel) : 'h2',
          styles: {
            width: blockState.titleWidth ? blockState.titleWidth : null
          },
          children: title
        })
      }), !descriptionBelowOption && renderDescription(), !descriptionBelowOption && renderSubDescription(), !descriptionBelowOption && renderCta(), blockState.textFadeIn !== false && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(react_waypoint__WEBPACK_IMPORTED_MODULE_17__/* .Waypoint */ .h, {
        onEnter: _handleWaypointEnter
      }), contentOptions && renderContentOptions(), descriptionBelowOption && renderDescription(), descriptionBelowOption && renderSubDescription(), descriptionBelowOption && renderCta()]
    })
  });

  var RenderContentWithImageAndTextSeparate = function RenderContentWithImageAndTextSeparate(props) {
    var _mobiledeviceConfigur9, _mobiledeviceConfigur10, _mobiledeviceConfigur11, _mobiledeviceConfigur12;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)(react__WEBPACK_IMPORTED_MODULE_12__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(BackgroundWrapper, {
        pauseLabel: pauseLabel,
        playLabel: playLabel,
        resetLabel: resetLabel,
        openTranscriptLabel: openTranscriptLabel,
        closeTranscriptLabel: closeTranscriptLabel,
        backgroundAsset: blockState.backgroundAsset,
        sectionOffsetTop: blockState.sectionOffsetTop,
        backgroundPosition: blockState.backgroundPosition,
        mainAssetOffsetTop: blockState.mainAssetOffsetTop,
        mainAssetOffsetRight: blockState.mainAssetOffsetRight,
        mainAssetOffsetBottom: blockState.mainAssetOffsetBottom,
        mainAssetOffsetLeft: blockState.mainAssetOffsetLeft,
        preloadImage: preloadBackgroundImage,
        desktopBackgroundImage: desktopBackgroundImage,
        mobileBackgroundImage: mobileBackgroundImage,
        children: blockState.secondaryAsset && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
          className: "secondary-asset",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Image, {
            scale: null,
            image: blockState.secondaryAsset,
            assetX: assetX,
            assetY: assetY,
            hasAssetParallax: hasAssetParallax,
            className: "\n                                ".concat(isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && ((_mobiledeviceConfigur9 = mobiledeviceConfiguration) == null ? void 0 : _mobiledeviceConfigur9.mainAssetHorizontalAlignment) ? "horizontal-".concat(mobiledeviceConfiguration.mainAssetHorizontalAlignment) : blockState.mainAssetHorizontalAlignment && "horizontal-".concat(blockState.mainAssetHorizontalAlignment), "\n                                ").concat(isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && ((_mobiledeviceConfigur10 = mobiledeviceConfiguration) == null ? void 0 : _mobiledeviceConfigur10.mainAssetVerticalAlignment) ? "vertical-".concat(mobiledeviceConfiguration.mainAssetVerticalAlignment) : blockState.mainAssetVerticalAlignment && "vertical-".concat(blockState.mainAssetVerticalAlignment), "\n                    ")
          })
        })
      }), !isTextAlignBottomMobileView && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
        className: "ob-contentBlock-wrapper ".concat(isPreloadimage && isPageLoaded ? 'show' : show, " ").concat(hasDivider ? 'ob-contentBlock-wrapper--has-divider' : ''),
        style: {
          padding: blockState.blockPadding ? blockState.blockPadding : null
        },
        children: [blockState.textFadeIn !== false && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(react_waypoint__WEBPACK_IMPORTED_MODULE_17__/* .Waypoint */ .h, {
          onEnter: _handleWaypointEnter
        }), blockState.mainAsset && blockState.mainAssetBelowOrAboveText === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.aboveText */ .Kd.aboveText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
          className: "ob-contentBlock-mainAsset-container",
          style: {
            width: blockState.mainAssetMaxWidth ? blockState.mainAssetMaxWidth : null,
            height: blockState.mainAssetHeight ? blockState.mainAssetHeight : null,
            maxHeight: blockState.mainAssetMaxHeight ? blockState.mainAssetMaxHeight : null,
            marginRight: blockState.mainAssetOffsetRight ? blockState.mainAssetOffsetRight : null,
            marginLeft: blockState.mainAssetOffsetLeft ? blockState.mainAssetOffsetLeft : null,
            marginTop: blockState.mainAssetOffsetTop ? blockState.mainAssetOffsetTop : null,
            marginBottom: blockState.mainAssetOffsetBottom ? blockState.mainAssetOffsetBottom : null
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Image, {
            scale: blockState.mainAssetScale,
            image: blockState.mainAsset,
            assetX: assetX,
            assetY: assetY,
            hasAssetParallax: hasAssetParallax,
            className: "\n                            ".concat(isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && ((_mobiledeviceConfigur11 = mobiledeviceConfiguration) == null ? void 0 : _mobiledeviceConfigur11.mainAssetHorizontalAlignment) ? "horizontal-".concat(mobiledeviceConfiguration.mainAssetHorizontalAlignment) : blockState.mainAssetHorizontalAlignment && "horizontal-".concat(blockState.mainAssetHorizontalAlignment), "\n                            ").concat(isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && ((_mobiledeviceConfigur12 = mobiledeviceConfiguration) == null ? void 0 : _mobiledeviceConfigur12.mainAssetVerticalAlignment) ? "vertical-".concat(mobiledeviceConfiguration.mainAssetVerticalAlignment) : blockState.mainAssetVerticalAlignment && "vertical-".concat(blockState.mainAssetVerticalAlignment), "\n                        ")
          })
        }), (valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.description */ .Kd.description) || title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
          className: "ob-contentBlock-textContent\n                        ".concat(isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && mobiledeviceConfiguration ? "horizontal-".concat(mobiledeviceConfiguration.textContainerHorizontalAlignment) : blockState.textContainerHorizontalAlignment && "horizontal-".concat(blockState.textContainerHorizontalAlignment), "\n                        ").concat(isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && mobiledeviceConfiguration ? "vertical-".concat(mobiledeviceConfiguration.textContainerVerticalAlignment) : blockState.textContainerVerticalAlignment && "vertical-".concat(blockState.textContainerVerticalAlignment), "               \n                    "),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
            className: "ob-contentBlock-textContent-inner".concat(textContainerHasPadding ? ' hasPadding' : '', " "),
            "data-width-text": windowWidth,
            style: {
              marginTop: blockState.textContainerOffset ? blockState.textContainerOffset : null,
              marginBottom: blockState.textContainerMarginBottom ? blockState.textContainerMarginBottom : null,
              marginLeft: blockState.textContainerMarginLeft ? blockState.textContainerMarginLeft : null,
              marginRight: blockState.textContainerMarginRight ? blockState.textContainerMarginRight : null,
              backgroundColor: textContainerBackgroundColor ? textContainerBackgroundColor : null,
              textAlign: isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && mobiledeviceConfiguration ? mobiledeviceConfiguration.textAlign : blockState.textAlign ? blockState.textAlign : null,
              width: isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && mobiledeviceConfiguration ? mobiledeviceConfiguration.textContainerWidth : blockState.textContainerWidth ? blockState.textContainerWidth : null
            },
            children: !isRemoveParallax ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(react_scroll_parallax__WEBPACK_IMPORTED_MODULE_16__/* .Parallax */ .VS, {
              className: "ob-contentBlock-textContent-parallax",
              x: textX,
              y: textY,
              disabled: !hasTextParallax,
              children: parallexCont
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
              className: "ob-contentBlock-textContent-parallax",
              x: textX,
              y: textY,
              disabled: !hasTextParallax,
              children: parallexCont
            })
          }), disclaimerReference && !blockState.mainAsset && renderDisclaimer(), disclaimerReference && blockState.mainAsset && !isMedium && renderDisclaimer()]
        }), blockState.mainAsset && (blockState.mainAssetBelowOrAboveText === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.belowText */ .Kd.belowText || blockState.mainAssetBelowOrAboveText === '') && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
          className: "ob-contentBlock-mainAsset-container",
          style: {
            width: blockState.mainAssetMaxWidth ? blockState.mainAssetMaxWidth : null,
            height: blockState.mainAssetHeight ? blockState.mainAssetHeight : null,
            maxHeight: blockState.mainAssetMaxHeight ? blockState.mainAssetMaxHeight : null,
            marginRight: blockState.mainAssetOffsetRight ? blockState.mainAssetOffsetRight : null,
            marginLeft: blockState.mainAssetOffsetLeft ? blockState.mainAssetOffsetLeft : null,
            marginTop: blockState.mainAssetOffsetTop ? blockState.mainAssetOffsetTop : null,
            marginBottom: blockState.mainAssetOffsetBottom ? blockState.mainAssetOffsetBottom : null
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Image, {
            scale: blockState.mainAssetScale,
            image: blockState.mainAsset,
            assetX: assetX,
            assetY: assetY,
            hasAssetParallax: hasAssetParallax,
            className: "\n          ".concat(blockState.mainAssetHorizontalAlignment && "horizontal-".concat(blockState.mainAssetHorizontalAlignment), "\n          ").concat(blockState.mainAssetVerticalAlignment && "vertical-".concat(blockState.mainAssetVerticalAlignment), "\n  ")
          })
        }), disclaimerReference && isMedium && blockState.mainAsset && renderDisclaimer()]
      })]
    });
  };

  var RenderContentWithoutImageAndTextSeparate = function RenderContentWithoutImageAndTextSeparate(props) {
    var _mobiledeviceConfigur13, _mobiledeviceConfigur14, _mobiledeviceConfigur15, _mobiledeviceConfigur16;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)(BackgroundWrapper, {
      pauseLabel: pauseLabel,
      playLabel: playLabel,
      resetLabel: resetLabel,
      openTranscriptLabel: openTranscriptLabel,
      closeTranscriptLabel: closeTranscriptLabel,
      backgroundAsset: blockState.backgroundAsset,
      sectionOffsetTop: blockState.sectionOffsetTop,
      backgroundPosition: blockState.backgroundPosition,
      mainAssetOffsetTop: blockState.mainAssetOffsetTop,
      mainAssetOffsetRight: blockState.mainAssetOffsetRight,
      mainAssetOffsetBottom: blockState.mainAssetOffsetBottom,
      mainAssetOffsetLeft: blockState.mainAssetOffsetLeft,
      preloadImage: preloadBackgroundImage,
      desktopBackgroundImage: desktopBackgroundImage,
      mobileBackgroundImage: mobileBackgroundImage,
      children: [!isTextAlignBottomMobileView && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
        className: "ob-contentBlock-wrapper ".concat(isPreloadimage && isPageLoaded ? 'show' : show, " ").concat(hasDivider ? 'ob-contentBlock-wrapper--has-divider' : ''),
        style: {
          padding: blockState.blockPadding ? blockState.blockPadding : null
        },
        children: [blockState.textFadeIn !== false && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(react_waypoint__WEBPACK_IMPORTED_MODULE_17__/* .Waypoint */ .h, {
          onEnter: _handleWaypointEnter
        }), blockState.mainAsset && blockState.mainAssetBelowOrAboveText === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.aboveText */ .Kd.aboveText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
          className: "ob-contentBlock-mainAsset-container",
          style: {
            width: blockState.mainAssetMaxWidth ? blockState.mainAssetMaxWidth : null,
            height: blockState.mainAssetHeight ? blockState.mainAssetHeight : null,
            maxHeight: blockState.mainAssetMaxHeight ? blockState.mainAssetMaxHeight : null,
            marginRight: blockState.mainAssetOffsetRight ? blockState.mainAssetOffsetRight : null,
            marginLeft: blockState.mainAssetOffsetLeft ? blockState.mainAssetOffsetLeft : null,
            marginTop: blockState.mainAssetOffsetTop ? blockState.mainAssetOffsetTop : null,
            marginBottom: blockState.mainAssetOffsetBottom ? blockState.mainAssetOffsetBottom : null
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Image, {
            scale: blockState.mainAssetScale,
            image: blockState.mainAsset,
            assetX: assetX,
            assetY: assetY,
            hasAssetParallax: hasAssetParallax,
            className: "\n                              ".concat(isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && ((_mobiledeviceConfigur13 = mobiledeviceConfiguration) == null ? void 0 : _mobiledeviceConfigur13.mainAssetHorizontalAlignment) ? "horizontal-".concat(mobiledeviceConfiguration.mainAssetHorizontalAlignment) : blockState.mainAssetHorizontalAlignment && "horizontal-".concat(blockState.mainAssetHorizontalAlignment), "\n                              ").concat(isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && ((_mobiledeviceConfigur14 = mobiledeviceConfiguration) == null ? void 0 : _mobiledeviceConfigur14.mainAssetVerticalAlignment) ? "vertical-".concat(mobiledeviceConfiguration.mainAssetVerticalAlignment) : blockState.mainAssetVerticalAlignment && "vertical-".concat(blockState.mainAssetVerticalAlignment), "\n                          ")
          })
        }), (valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.description */ .Kd.description) || title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
          className: "ob-contentBlock-textContent\n                          ".concat(isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && mobiledeviceConfiguration ? "horizontal-".concat(mobiledeviceConfiguration.textContainerHorizontalAlignment) : blockState.textContainerHorizontalAlignment && "horizontal-".concat(blockState.textContainerHorizontalAlignment), "\n                          ").concat(isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && mobiledeviceConfiguration ? "vertical-".concat(mobiledeviceConfiguration.textContainerVerticalAlignment) : blockState.textContainerVerticalAlignment && "vertical-".concat(blockState.textContainerVerticalAlignment), "               \n                      "),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
            className: "ob-contentBlock-textContent-inner".concat(textContainerHasPadding ? ' hasPadding' : '', " "),
            "data-width-text": windowWidth,
            style: {
              marginTop: blockState.textContainerOffset ? blockState.textContainerOffset : null,
              marginBottom: blockState.textContainerMarginBottom ? blockState.textContainerMarginBottom : null,
              marginLeft: blockState.textContainerMarginLeft ? blockState.textContainerMarginLeft : null,
              marginRight: blockState.textContainerMarginRight ? blockState.textContainerMarginRight : null,
              backgroundColor: textContainerBackgroundColor ? textContainerBackgroundColor : null,
              textAlign: isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && mobiledeviceConfiguration ? mobiledeviceConfiguration.textAlign : blockState.textAlign ? blockState.textAlign : null,
              width: isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && mobiledeviceConfiguration ? mobiledeviceConfiguration.textContainerWidth : blockState.textContainerWidth ? blockState.textContainerWidth : null
            },
            children: !isRemoveParallax ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(react_scroll_parallax__WEBPACK_IMPORTED_MODULE_16__/* .Parallax */ .VS, {
              className: "ob-contentBlock-textContent-parallax",
              x: textX,
              y: textY,
              disabled: !hasTextParallax,
              children: parallexCont
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
              className: "ob-contentBlock-textContent-parallax",
              x: textX,
              y: textY,
              disabled: !hasTextParallax,
              children: parallexCont
            })
          }), disclaimerReference && !blockState.mainAsset && renderDisclaimer(), disclaimerReference && blockState.mainAsset && !isMedium && renderDisclaimer()]
        }), blockState.mainAsset && (blockState.mainAssetBelowOrAboveText === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.belowText */ .Kd.belowText || blockState.mainAssetBelowOrAboveText === '') && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
          className: "ob-contentBlock-mainAsset-container",
          style: {
            width: blockState.mainAssetMaxWidth ? blockState.mainAssetMaxWidth : null,
            height: blockState.mainAssetHeight ? blockState.mainAssetHeight : null,
            maxHeight: blockState.mainAssetMaxHeight ? blockState.mainAssetMaxHeight : null,
            marginRight: blockState.mainAssetOffsetRight ? blockState.mainAssetOffsetRight : null,
            marginLeft: blockState.mainAssetOffsetLeft ? blockState.mainAssetOffsetLeft : null,
            marginTop: blockState.mainAssetOffsetTop ? blockState.mainAssetOffsetTop : null,
            marginBottom: blockState.mainAssetOffsetBottom ? blockState.mainAssetOffsetBottom : null
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Image, {
            scale: blockState.mainAssetScale,
            image: blockState.mainAsset,
            assetX: assetX,
            assetY: assetY,
            hasAssetParallax: hasAssetParallax,
            className: "\n                              ".concat(blockState.mainAssetHorizontalAlignment && "horizontal-".concat(blockState.mainAssetHorizontalAlignment), "\n                              ").concat(blockState.mainAssetVerticalAlignment && "vertical-".concat(blockState.mainAssetVerticalAlignment), "\n                      ")
          })
        }), disclaimerReference && isMedium && blockState.mainAsset && renderDisclaimer()]
      }), blockState.secondaryAsset && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
        className: "secondary-asset",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Image, {
          scale: null,
          image: blockState.secondaryAsset,
          assetX: assetX,
          assetY: assetY,
          hasAssetParallax: hasAssetParallax,
          className: "\n                                      ".concat(isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && ((_mobiledeviceConfigur15 = mobiledeviceConfiguration) == null ? void 0 : _mobiledeviceConfigur15.mainAssetHorizontalAlignment) ? "horizontal-".concat(mobiledeviceConfiguration.mainAssetHorizontalAlignment) : blockState.mainAssetHorizontalAlignment && "horizontal-".concat(blockState.mainAssetHorizontalAlignment), "\n                                      ").concat(isPreloadimage && windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.defaultWindWidth */ .Kd.defaultWindWidth && ((_mobiledeviceConfigur16 = mobiledeviceConfiguration) == null ? void 0 : _mobiledeviceConfigur16.mainAssetVerticalAlignment) ? "vertical-".concat(mobiledeviceConfiguration.mainAssetVerticalAlignment) : blockState.mainAssetVerticalAlignment && "vertical-".concat(blockState.mainAssetVerticalAlignment), "\n                          ")
        })
      })]
    });
  };

  return isContentHyperlinkBlock ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("a", {
    href: blockHyperlink,
    target: "_blank",
    "aria-label": anchorId,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("section", {
      className: "ob-contentBlock content ".concat(className ? className : '', " ").concat(blockState.textShowAnimation, " ").concat(blockState.backgroundAsset ? '' : 'no-background', " ").concat(blockState.mainAssetBelowOrAboveText === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.aboveText */ .Kd.aboveText ? 'image-above' : '', " ").concat(blockState.mainAssetBelowOrAboveText === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.belowText */ .Kd.belowText ? 'image-below' : ''),
      id: anchorId,
      style: {
        backgroundColor: backgroundColor ? backgroundColor : null,
        minHeight: blockState.blockMinHeight ? blockState.blockMinHeight : null,
        marginTop: blockState.blockMarginTop ? blockState.blockMarginTop : null,
        marginBottom: blockState.blockMarginBottom ? blockState.blockMarginBottom : null,
        marginRight: blockState.blockMarginRight ? blockState.blockMarginRight : null,
        marginLeft: blockState.blockMarginLeft ? blockState.blockMarginLeft : null
      },
      "data-respectimageaspectratio": blockState.respectImageAspectRatio,
      children: [mobileMainHeading && (isSmall || isXSmall) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("div", {
        className: "mobile-main-heading",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Heading, {
          className: titleFontSize,
          whiteText: isWhiteText,
          tag: titleLevel ? "h".concat(titleLevel) : 'h2',
          styles: {
            width: blockState.titleWidth || null
          },
          children: mobileMainHeading
        })
      }), (isContentMobile == null ? void 0 : (_isContentMobile$ = isContentMobile[1]) == null ? void 0 : _isContentMobile$.deviceType) === 'mobile' && (isContentMobile == null ? void 0 : (_isContentMobile$2 = isContentMobile[1]) == null ? void 0 : _isContentMobile$2.isContentImageAndTextSeparate) && (isMedium || isSmall || isXSmall) ? RenderContentWithImageAndTextSeparate(props) : RenderContentWithoutImageAndTextSeparate(props), isTextAlignBottomMobileView && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
        className: "text-align-bottom-mobile-view",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Heading, {
          className: titleFontSize,
          whiteText: isWhiteText,
          tag: titleLevel ? "h".concat(titleLevel) : 'h2',
          styles: {
            width: blockState.titleWidth ? blockState.titleWidth : null
          },
          children: title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(BodyText, {
          whiteText: isWhiteText,
          className: className,
          styles: {
            width: blockState.descriptionWidth ? blockState.descriptionWidth : null
          },
          children: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.description */ .Kd.description)
        })]
      }), isRenderAppIcons && renderAppIcons(), noteText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("p", {
        className: "ob-note-text",
        children: noteText
      })]
    })
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("section", {
    className: "ob-contentBlock content ".concat(className ? className : '', " ").concat(blockState.textShowAnimation, " ").concat(blockState.backgroundAsset ? '' : 'no-background', " ").concat(blockState.mainAssetBelowOrAboveText === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.aboveText */ .Kd.aboveText ? 'image-above' : '', " ").concat(blockState.mainAssetBelowOrAboveText === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.belowText */ .Kd.belowText ? 'image-below' : ''),
    id: anchorId,
    style: {
      backgroundColor: backgroundColor ? backgroundColor : null,
      minHeight: blockState.blockMinHeight ? blockState.blockMinHeight : null,
      marginTop: blockState.blockMarginTop ? blockState.blockMarginTop : null,
      marginBottom: blockState.blockMarginBottom ? blockState.blockMarginBottom : null,
      marginRight: blockState.blockMarginRight ? blockState.blockMarginRight : null,
      marginLeft: blockState.blockMarginLeft ? blockState.blockMarginLeft : null
    },
    "data-respectimageaspectratio": blockState.respectImageAspectRatio,
    children: [(isContentMobile == null ? void 0 : (_isContentMobile$3 = isContentMobile[1]) == null ? void 0 : _isContentMobile$3.deviceType) === 'mobile' && (isContentMobile == null ? void 0 : (_isContentMobile$4 = isContentMobile[1]) == null ? void 0 : _isContentMobile$4.isContentImageAndTextSeparate) && (isMedium || isSmall || isXSmall) ? RenderContentWithImageAndTextSeparate(props) : RenderContentWithoutImageAndTextSeparate(props), isTextAlignBottomMobileView && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsxs)("div", {
      className: "text-align-bottom-mobile-view",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(Heading, {
        className: titleFontSize,
        whiteText: isWhiteText,
        tag: titleLevel ? "h".concat(titleLevel) : 'h2',
        styles: {
          width: blockState.titleWidth ? blockState.titleWidth : null
        },
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)(BodyText, {
        whiteText: isWhiteText,
        className: className,
        styles: {
          width: blockState.descriptionWidth ? blockState.descriptionWidth : null
        },
        children: valueOf(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_19__/* .ContentConstants.description */ .Kd.description)
      })]
    }), isRenderAppIcons && renderAppIcons(), noteText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_26__.jsx)("p", {
      className: "ob-note-text",
      children: noteText
    })]
  });
}

/* harmony default export */ __webpack_exports__["default"] = ((0,_adapters_helpers_Hooks__WEBPACK_IMPORTED_MODULE_23__/* .mediaQueryHOC */ .Ui)(ContentBlock)); // This export is for unit testing (do not remove) :

var ContentBlockTest = ContentBlock;

/***/ }),

/***/ 44291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Label": function() { return /* binding */ Label; },
/* harmony export */   "LabelHTML": function() { return /* binding */ LabelHTML; },
/* harmony export */   "replaceTokensFromString": function() { return /* binding */ replaceTokensFromString; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3323);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(24603);
/* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(88386);
/* harmony import */ var core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(67294);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(85893);












var _excluded = ["label", "tokens"];






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





/* harmony default export */ __webpack_exports__["default"] = (Label);
function Label(_ref) {
  var label = _ref.label,
      tokens = _ref.tokens;

  if (!label) {
    return '';
  } else if (tokens) {
    var _label$fields;

    return replaceTokensFromString((label == null ? void 0 : (_label$fields = label.fields) == null ? void 0 : _label$fields.text) || label, tokens);
  } else {
    var _label$fields2;

    return (label == null ? void 0 : (_label$fields2 = label.fields) == null ? void 0 : _label$fields2.text) || label;
  }
}
Label.propTypes = {
  label: prop_types__WEBPACK_IMPORTED_MODULE_17___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_17___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_17___default().object)]),
  tokens: (prop_types__WEBPACK_IMPORTED_MODULE_17___default().object)
};
function LabelHTML(_ref2) {
  var label = _ref2.label,
      tokens = _ref2.tokens,
      props = _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11___default()(_ref2, _excluded);

  if (!label) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", _objectSpread({}, props));
  } else if (tokens) {
    var _label$fields3;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", _objectSpread({
      dangerouslySetInnerHTML: {
        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19___default().sanitize(replaceTokensFromString((label == null ? void 0 : (_label$fields3 = label.fields) == null ? void 0 : _label$fields3.text) || label, tokens))
      }
    }, props));
  } else {
    var _label$fields4;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", _objectSpread({
      dangerouslySetInnerHTML: {
        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19___default().sanitize((label == null ? void 0 : (_label$fields4 = label.fields) == null ? void 0 : _label$fields4.text) || label)
      }
    }, props));
  }
}
function replaceTokensFromString(s, tokens) {
  for (var tokenKey in tokens) {
    s = s.replace(new RegExp('{' + tokenKey + '}', 'g'), tokens[tokenKey]);
  }

  return s;
}

/***/ }),

/***/ 3323:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(57826);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 57826:
/***/ (function(module) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ })

}]);